export const environment = {
  url: {
    api: `https://apim-dev.houseofhr.com/square-app-timepartner/api/v2.0`,
  },
  production: false,
  ocpApimSubscriptionKey: '8d2c047311bf485abe6180657e5d8375'
};

